import { defineComponent } from "vue"
import cleanup from "../utils/barcode_cleanup"

export default defineComponent({
  data() {
    return { barcode: cleanup(this.value) }
  },
  methods: {
    cleanup() {
      this.barcode = cleanup(this.barcode)
    },
  },
  props: ["name", "value", "placeholder"] as const,
  render() {
    return (
      <input
        value={this.barcode}
        onInput={(e: Event) => {
          this.barcode = (e.target as HTMLInputElement).value
        }}
        autocomplete="off"
        class="form-control"
        name={this.name}
        placeholder={this.placeholder}
        type="text"
      />
    )
  },
  watch: {
    barcode() {
      this.cleanup()
    },
  },
})
